<well-signup-card-layout [title]="'signup.companyInfo.title' | translate" [icon]="true">
  <i [ngClass]="iconClass" rightIcon></i>
  <signup-legal-entity-inputs (save)="onSave($event)" [type]="companyType" body>
  </signup-legal-entity-inputs>
</well-signup-card-layout>

<p-dialog [modal]="true"
          [(visible)]="confirmDialogVisible"
          [closable]="false"
          [header]="'signup.companyInfo.confirmLegalEntitySignup' | translate"
>
  <div class="col-12 px-4 py-3 text-center">
    <p>{{'signup.companyInfo.reLoginRequired' | translate}}</p>
    <p>{{'signup.companyInfo.redirectingInSeconds' | translate: {seconds: redirectCountdown} }}</p>
  </div>
</p-dialog>


